<div class="content-wrapper">

  <section class="content-header">
    <h1>
      Notícias
      <small>Preencha as informações necessárias</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="/home">
          <i class="fa fa-home"></i> Home</a>
      </li>
      <li>
        <a routerLink="/noticias">Notícias</a>
      </li>
      <li class="active">Inserir</li>
    </ol>
  </section>

  <br>

  <div class="col-md-12">

    <div class="box box-primary">

      <div class="panel-body">

        <h3>Informações</h3>
        <hr>

        <!-- <div class="ui-g">

          <div class="ui-g-12 ui-md-6 ui-fluid">
            <label>Notícias para:</label>
            <p-select name="entidade" [options]="opcoes" placeholder="Selecione" [filter]="true" required></p-select>
          </div>


          <div class="ui-g-12 ui-fluid">
            <label>Título:</label>
            <input pInputText type="text" name="titulo" required>
          </div>

          <div class="ui-g-12 ui-fluid">
            <label>Descrição / Conteúdo:</label>
            <p-editor name="resumo" [style]="{'height':'300px', 'background':'#fff'}"></p-editor>
          </div>

          <br>
          <br>
        </div> -->

        <div class="box-footer">
          <button type="submit" class="btn btn-primary ">Salvar</button>
          &nbsp;
          <a>Limpar formulário</a>
        </div>

      </div>

    </div>

  </div>

</div>